import { Link } from 'react-router-dom';
import logo from "../../assets/img/logo-2.png";
import subscribeBg from "../../assets/img/page/banner-video.png";
import blogData from '../../data/blog-data';

const FooterTwo = () => {
    return (
        <>
            <div className="footer__two">
                <div className="subscribe__area">
                    <div className="container">
                        <div className="row align-items-center subscribe__area-bg" style={{backgroundImage: `url(${subscribeBg})`}}>
                            <div className="col-lg-6 lg-mb-40 lg-t-center">
                                <div className="subscribe__area-left title_split_anim">
                                    <h2>Begin Your Dream Project Today!</h2>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="subscribe__area-form wow fadeInUp" data-wow-delay=".4s">
                                    <form>
                                        <input type="email" name="email" placeholder="Email address" />
                                        <button className="build_button" type="submit">Subscribe Now</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="footer__two-widget">
                                <div className="footer__two-widget-about">
                                    <Link to="/"><img src={logo} alt="Arclight Developers logo" /></Link>
                                    <p>Redefining the civil engineering and construction industry with innovative infrastructure solutions and sustainable practices.</p>
                                    <div className="footer__two-widget-about-social">
                                        {/* Social Component Removed */}
                                    </div>							
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 md-mt-30">
                            <div className="footer__two-widget footer-border pl-60 md-pl-0">
                                <h4>Contact Us</h4>
                                <div className="footer__two-widget-location">
                                    <div className="footer__two-widget-location-item">
                                        <div className="footer__two-widget-location-item-icon">
                                            <i className="flaticon-location"></i>
                                        </div>
                                        <div className="footer__two-widget-location-item-info">
                                            <a href="#" target="_blank" rel="noopener noreferrer">246/B, Purusangit Bunglow, Sector 7A, Gandhingar, Gujarat, 382007</a>
                                        </div>
                                    </div>
                                    <h6 className="mt-20">Get In Touch</h6>
                                    <div className="footer__two-widget-location-item">
                                        <div className="footer__two-widget-location-item-icon">
                                            <i className="flaticon-phone"></i>
                                        </div>
                                        <div className="footer__two-widget-location-item-info">
                                            <a href="tel:+919909417333">+91 99094 17333</a><br/>
                                            <a href="tel:+919558554419">+91 95585 54419</a><br/>
                                            <a href="mailto:arclightdevelopers@gmail.com">arclightdevelopers@gmail.com</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 lg-mt-30">
                            <div className="footer__two-widget footer-border pl-60 lg-pl-0">
                                <h4>Recent Post</h4>
                                <div className="all__sidebar-item-post">
                                    {blogData?.slice(0, 2)?.map((data, id) => (
                                        <div className="post__item" key={id}>
                                            <div className="post__item-image">
                                                <Link to={`/blog/${data.id}`}><img src={data.image} alt={data.title} /></Link>
                                            </div>
                                            <div className="post__item-title">
                                                <span><i className="far fa-calendar-alt"></i>Mar {data.date}, 2026</span>
                                                <h6><Link to={`/blog/${data.id}`}>{data.title}</Link></h6>
                                            </div>
                                        </div>
                                    ))}
                                </div>	
                            </div>
                        </div>
                    </div>
                </div>	
            </div>
            <div className="copyright__area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright__area-content t-center">
                                <p>Copyright 2025 – All Rights Reserved By <Link to="/" target="_blank">Arclight Developers</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterTwo;